module.exports = __webpack_public_path__ + "img/crate-apple.4c11e09e.svg";